import API from '../../apis';
import { action, generateErrorAction } from '../actions';
import actionTypes from './actionTypes';

export const fetchAllUserInvoices = (id, query) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.invoices
        .fetchAllUserInvoicesById(id, query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_ALL_USER_INVOICES_FAILED,
              reject: actionTypes.FETCH_ALL_USER_INVOICES_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_ALL_USER_INVOICES_LOADING);
  const success = res => action(actionTypes.FETCH_ALL_USER_INVOICES_SUCCESS, res);

  return request();
};

export const temproraySaveInvoice = (id, invoiceItems) => {
  const request = () => {
    return dispatch => {
      dispatch(loading(id));
      return API.reservations
        .temproraySaveInvoice(id, invoiceItems)
        .then(res => {
          dispatch(success(res));
          return res;
        })
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.TEMPORARY_SAVE_INVOICE_FAILED,
              reject: actionTypes.TEMPORARY_SAVE_INVOICE_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.TEMPORARY_SAVE_INVOICE_LOADING);
  const success = res => action(actionTypes.TEMPORARY_SAVE_INVOICE_SUCCESS, res);

  return request();
};

export const finalSaveInvoice = (id, invoiceItems) => {
  const request = () => {
    return dispatch => {
      dispatch(loading(id));
      return API.reservations
        .finalSaveInvoice(id, invoiceItems)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FINAL_SAVE_INVOICE_FAILED,
              reject: actionTypes.FINAL_SAVE_INVOICE_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FINAL_SAVE_INVOICE_LOADING);
  const success = res => action(actionTypes.FINAL_SAVE_INVOICE_SUCCESS, res);

  return request();
};
